import script from "./Sidentify.vue?vue&type=script&setup=true&lang=js"
export * from "./Sidentify.vue?vue&type=script&setup=true&lang=js"

import "./Sidentify.vue?vue&type=style&index=0&id=78da7bd4&lang=less"

const __exports__ = script;

export default __exports__